























































































import { Component, Vue } from "vue-property-decorator";
import Cookies from "js-cookie";

@Component({
  components: {}
})
export default class GetStarted extends Vue {
  private loggedIn = (Cookies.get("sqfsafe_auth") != undefined);

}

